import { render, staticRenderFns } from "./FaqTestFileUpload.vue?vue&type=template&id=4d167bd2&scoped=true&"
import script from "./FaqTestFileUpload.vue?vue&type=script&lang=js&"
export * from "./FaqTestFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./FaqTestFileUpload.vue?vue&type=style&index=0&id=4d167bd2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d167bd2",
  null
  
)

export default component.exports